import { useState, useEffect } from 'react'
import { Close } from '@mui/icons-material'
import Modal from 'react-modal'
import useFetch from '../../hooks/useFetch'
import { urlApi } from '../../config'
import LobbyCard from '../../common/LobbyCard'
import LobbyInfo from '../../common/LobbyInfo'
import LoadingIndicator from '../../common/LoadingIndicator'

export default function UserLobbies({ userLobbiesVisible, setUserLobbiesVisible, userId }) {
  const { loading, data } = useFetch(`${urlApi}/admin/users/lobbies/${userId}`)
  const [selectedLobby, setSelectedLobby] = useState({})

  const customStyles = {
    content: {
      borderRadius: '1.5rem',
      marginTop: 'auto',
      marginBottom: 'auto',
      paddingLeft: '1.6rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    overlay: {
      zIndex: 90,
      backgroundColor: 'rgba(0,0,0,0.5)'
    }
  }

  const sortLobbies = lobbies =>
    lobbies.sort((a, b) => {
      const dateA = a.Journey.departure_time
      const dateB = b.Journey.departure_time
      return dateA > dateB ? -1 : 1
    })

  return (
    <>
      <Modal
        isOpen={userLobbiesVisible}
        onRequestClose={() => setUserLobbiesVisible(false)}
        style={customStyles}
      >
        <div className='flex flex-col h-full'>
          <Close onClick={() => setUserLobbiesVisible(false)} />
          {loading ? (
            <div className='flex h-full items-center justify-center'>
              <LoadingIndicator />
            </div>
          ) : data?.length > 0 ? (
            <ol className='overflow-auto h-screen'>
              {sortLobbies(data).map(lobby => (
                <li key={lobby.id || Math.random()}>
                  <LobbyCard lobby={lobby} setSelected={setSelectedLobby} userId={userId} />
                </li>
              ))}
              <li className='text-xl text-center'>FIN</li>
            </ol>
          ) : (
            <div className='flex justify-center'>
              <p>No hay viajes</p>
            </div>
          )}
        </div>
      </Modal>

      {Object.keys(selectedLobby).length != 0 && (
        <PreLobbyInfo lobbyId={selectedLobby._id} setSelectedLobby={setSelectedLobby} />
      )}
    </>
  )
}

const PreLobbyInfo = ({ lobbyId, setSelectedLobby }) => {
  const { loading, data } = useFetch(`${urlApi}/admin/lobbies/${lobbyId}`)
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    if (!loading) setVisible(false)
  }, [loading])

  return (
    <>
      <Modal
        isOpen={visible}
        onRequestClose={() => setVisible(false)}
        style={{
          overlay: {
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 99
          },
          content: {
            width: '50%',
            height: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
            borderRadius: '10px',
            border: 'none',
            backgroundColor: '#f8f8f8',
            fontSize: '1.5rem'
          }
        }}
      >
        <LoadingIndicator />
      </Modal>
      {!loading && <LobbyInfo lobby={data} setSelected={setSelectedLobby} />}
    </>
  )
}

export { PreLobbyInfo }
